import { render, staticRenderFns } from "./Informine.vue?vue&type=template&id=2f666a68&scoped=true&"
import script from "./Informine.vue?vue&type=script&lang=js&"
export * from "./Informine.vue?vue&type=script&lang=js&"
import style0 from "./Informine.vue?vue&type=style&index=0&id=2f666a68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f666a68",
  null
  
)

export default component.exports